import { render } from "./IconTwoYellowRed.vue?vue&type=template&id=9e854dcc&ts=true"
import script from "./IconTwoYellowRed.vue?vue&type=script&lang=ts"
export * from "./IconTwoYellowRed.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__